import React, { FC, useState, useEffect, useCallback, useMemo } from 'react'

import { Grid, Header, Container, Icon, Menu, Button, Card } from 'semantic-ui-react'
import { ReactSVG } from 'react-svg'

import { StatsCard, StatsContainer, StatsHeader, StatsColored, LargestInRussia, StatsComponent } from './style'

export const Stats = (props) => {
    return (
        <StatsContainer>
            <StatsComponent>
                <LargestInRussia>
                    <ReactSVG src="/themes/defaultNiimko/images/new/largestInRussia.svg" />
                    <p>Крупнейший в России независимый оператор по оценке образовательных достижений
                    студентов на различных этапах обучения.</p>
                    <p>Ежегодные показатели использования сервисов:</p>
                </LargestInRussia>
                <Card.Group itemsPerRow={3} stackable>
                    <StatsCard>
                        <Card.Content textAlign="center">
                            Более<br/>
                            <StatsColored><StatsHeader>600</StatsHeader></StatsColored><br />
                            <span>образовательных организаций</span>
                        </Card.Content>
                    </StatsCard>
                
                    <StatsCard>
                        <Card.Content textAlign="center">
                            Более<br />
                            <StatsColored><StatsHeader>1,5</StatsHeader>млн</StatsColored><br />
                            <span>сеансов тестирования</span>
                        </Card.Content>
                    </StatsCard>
                
                    <StatsCard>
                        <Card.Content textAlign="center">
                            Более<br />
                            <StatsColored><StatsHeader>400</StatsHeader>тыс.</StatsColored><br />
                            <span>студентов</span>
                        </Card.Content>
                    </StatsCard>
                </Card.Group>
            </StatsComponent>
        </StatsContainer>
    )
}